import { LayoutDataType } from '../../types';

export const COMMUNICATE_OPTIONS: {
  id: NonNullable<LayoutDataType['communicate']>;
  title: string;
}[] = [
  {
    id: 'witty',
    title: '😏 Witty',
  },
  {
    id: 'romantic',
    title: '💖 Romantic',
  },
  {
    id: 'straightforward',
    title: '😊 Straightforward',
  },
  {
    id: 'flirty',
    title: '🔥 Flirty',
  },
];
